// TODO: #646 refactor this ...

import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { formatTimestamp } from '@services/formatTimestamp';
import colors from '@theme/colors';

class Timestamp extends PureComponent {
  render() {
    const StyledSpan = styled.span`
      color: ${colors.PRIMARY};
      display: inline-block;
      margin-top: 10px;
      margin-bottom: 30px;
      font-weight: bold;
    `;
    return <StyledSpan>[{formatTimestamp(this.props.timestamp)}]</StyledSpan>;
  }
}

Timestamp.propTypes = {
  timestamp: PropTypes.number.isRequired,
};

export default Timestamp;



// WEBPACK FOOTER //
// ./components/atoms/Timestamp.js